import { render, staticRenderFns } from "./InvestmentNavigationActions.vue?vue&type=template&id=8b6b98e2&"
import script from "./InvestmentNavigationActions.vue?vue&type=script&lang=js&"
export * from "./InvestmentNavigationActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports